// extracted by css-extract-rspack-plugin
export default {"button":"expand-button-module__button__P3D2W","expanded":"expand-button-module__expanded__DykXj"};